import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { AI_BLOCKED_SITES } from '@/constant/Constants';

dayjs.extend(relativeTime);

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatRelativeTime(date: Date): string {
  return dayjs(date).fromNow();
}

/**
 * Check if AI features should be disabled for the given site
 * @param siteName - The site name to check (e.g., 'marvel-test', 'blacklist-test')
 * @returns true if the site is in the blocklist, false otherwise
 */
export function isAiBlockedSite(siteName?: string): boolean {
  if (!siteName) return false;
  return AI_BLOCKED_SITES.includes(siteName);
}
